import dateHelper from "./dateHelper";

function filterList(originalList, fromDate, dayCount) {
  // We get the full event list and we would like to filter out some of them by date
  const toDate = dateHelper.getDateWithoutTime();

  toDate.setDate(fromDate.getDate() + dayCount);

  // Go through each event and keep only events that within the range
  const eventList = [];

  originalList.forEach((item) => {
    const startDate = new Date(item.startDate);
    const endDate = new Date(item.endDate);

    // Compare the date
    // 1. Start > from & Start < to
    // 2. End > from & End < to
    // 3. Start < from but End > to (event already in progress)
    if (
      (startDate >= fromDate && startDate <= toDate)
      || (endDate >= fromDate && endDate <= toDate)
      || (startDate <= fromDate && endDate >= toDate)
    ) eventList.push(item);
  });

  return eventList;
}

export default filterList;
